import { MapPin, MessageCircle } from "lucide-react";
import { waLink } from "@/lib/site";

const cities = [
  "Belém",
  "Ananindeua",
  "Marituba",
  "Benevides",
  "Barcarena",
  "Abaetetuba",
  "Castanhal",
  "Santa Izabel",
  "Vigia",
];

export default function Coverage() {
  return (
    <section id="regiao" className="bg-[#111111] border-y border-white/10">
      <div className="max-w-7xl mx-auto px-4 py-16 md:py-24">
        <p className="text-[#50CF08] uppercase tracking-widest text-sm font-semibold">Atendimento regional</p>
        <h2 className="font-bebas text-4xl md:text-6xl uppercase tracking-tight text-[#FEFB0E] mt-2">
          Guincho em Belém e Região
        </h2>
        <p className="mt-4 text-base md:text-lg text-neutral-400 max-w-3xl">
          A Brasil Transportes realiza serviços de reboque, guincho e assistência veicular em Belém
          e diversas cidades da Região Metropolitana e do Pará.
        </p>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-3 border border-white/10 rounded-md overflow-hidden">
          {cities.map((city) => (
            <div
              key={city}
              data-testid={`coverage-city-${city.toLowerCase().replace(/\s+/g, "-")}`}
              className={`flex items-center gap-3 px-5 py-6 border border-white/10 -m-px ${
                city === "Belém" ? "bg-[#FEFB0E] text-black" : "bg-[#0A0A0A]"
              }`}
            >
              <MapPin className={`w-5 h-5 shrink-0 ${city === "Belém" ? "text-black" : "text-[#50CF08]"}`} />
              <span className="font-bebas text-xl md:text-2xl uppercase tracking-wide">{city}</span>
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-col md:flex-row md:items-center gap-6">
          <p className="text-neutral-400 text-sm md:text-base">
            Também atendemos a Região Metropolitana de Belém e outras localidades do Pará mediante
            consulta. <strong className="text-white">Não encontrou sua cidade?</strong> Entre em
            contato e consulte disponibilidade.
          </p>
          <a
            href={waLink("Olá! Quero consultar disponibilidade de atendimento na minha cidade.")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="coverage-whatsapp-btn"
            className="shrink-0 inline-flex items-center justify-center gap-3 bg-[#50CF08] hover:bg-[#42B006] text-white font-extrabold uppercase px-8 py-4 rounded-md transition-all duration-300 hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-[#FEFB0E]"
          >
            <MessageCircle className="w-5 h-5" />
            Consultar disponibilidade
          </a>
        </div>
      </div>
    </section>
  );
}
